import { useContext } from 'react';
import type { FeatureGateEvaluationOptions } from '@statsig/js-client';
import { StatsigContext, useGateValue } from '@statsig/react-bindings';

import type { FeatureFlag } from '@/consts/featureFlags';
import { getStatsigClient } from '@/services/featureFlags';

export const WITHOUT_EXPOSURE: FeatureGateEvaluationOptions = Object.freeze({
  disableExposureLog: true,
});

export const useFeatureFlag = (flag: FeatureFlag, options?: FeatureGateEvaluationOptions): boolean =>
  useGateValue(flag, options) === true;

export const useFeatureFlagsReady = (): boolean => {
  const { isLoading } = useContext(StatsigContext);
  return !isLoading || getStatsigClient() === undefined;
};
